"use strict";

var _defineProperty = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("./utils");
var BACKSPACE_KEY = 8;
var LEFT_ARROW_KEY = 37;
var UP_ARROW_KEY = 38;
var RIGHT_ARROW_KEY = 39;
var DOWN_ARROW_KEY = 40;
var E_KEY = 69;
var DOT_KEY = 190;
var COMMA_KEY = 188;
var Types;
(function (Types) {
  Types["text"] = "text";
  Types["number"] = "number";
})(Types = exports.Types || (exports.Types = {}));
var CodeInput = function CodeInput(_ref) {
  var fields = _ref.fields,
    value = _ref.value,
    name = _ref.name,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? utils_1.defaultOnFocus : _ref$onFocus,
    autoFocus = _ref.autoFocus,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types.text : _ref$type,
    disabled = _ref.disabled,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    invalidInputClassName = _ref.invalidInputClassName;
  var _react_1$useState = react_1.useState(utils_1.fillEmptyArray(fields).map(function (element, i) {
      return value.split('')[i] || element;
    })),
    _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
    inputsValues = _react_1$useState2[0],
    setInputsValues = _react_1$useState2[1];
  var _react_1$useState3 = react_1.useState(utils_1.fillEmptyArray(fields).map(function (element, i) {
      return utils_1.uuid();
    })),
    _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
    inputsKeys = _react_1$useState4[0],
    setInputsKeys = _react_1$useState4[1];
  var inputsRefs = inputsValues.map(function () {
    return react_1.useRef({});
  });
  var handleChange = function handleChange(event) {
    var target = event.target;
    var value = target.value;
    if (value === '') {
      return;
    }
    var currInputIndex = Number(target.dataset.id);
    var nextInputIndex = currInputIndex + 1;
    var nextTarget = inputsRefs[nextInputIndex];
    var copiedInputsValues = inputsValues.slice();
    /** throwing focus on next input when the new value is equal
    to previous cause onChange doesn't fire in this case */
    if (value.length > 1) {
      value.split('').forEach(function (chart, i) {
        if (currInputIndex + i < copiedInputsValues.length) {
          copiedInputsValues[currInputIndex + i] = chart;
          /**Set focus on last input with value after ctrl + v */
          nextTarget = inputsRefs[currInputIndex + i];
        }
      });
    } else {
      copiedInputsValues[currInputIndex] = value;
    }
    if (nextTarget) {
      utils_1.moveToNewTarget(nextTarget);
    }
    setInputsValues(copiedInputsValues);
    if (onChange) {
      var fullValue = copiedInputsValues.join('');
      onChange(fullValue);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var target = event.currentTarget;
    var currInputIndex = Number(target.dataset.id);
    var nextInput = inputsRefs[currInputIndex + 1];
    var prevInput = inputsRefs[currInputIndex - 1];
    var currInput = inputsRefs[currInputIndex];
    switch (event.keyCode) {
      case BACKSPACE_KEY:
        var copiedInputsValues = inputsValues.slice();
        copiedInputsValues[currInputIndex] = '';
        //to completely update input; helpfull on adroid when comma not beeing registered
        var newKeys = inputsKeys.slice();
        newKeys[currInputIndex] = utils_1.uuid();
        setInputsValues(copiedInputsValues);
        setInputsKeys(newKeys);
        if (prevInput) {
          utils_1.moveToNewTarget(prevInput);
        } else {
          utils_1.updateFocus(currInput);
        }
        if (onChange) {
          var fullValue = copiedInputsValues.join('');
          onChange(fullValue);
        }
        break;
      case LEFT_ARROW_KEY:
        event.preventDefault();
        if (prevInput) {
          utils_1.moveToNewTarget(prevInput);
        }
        break;
      case RIGHT_ARROW_KEY:
        event.preventDefault();
        if (nextInput) {
          utils_1.moveToNewTarget(nextInput);
        }
        break;
      case UP_ARROW_KEY:
        event.preventDefault();
        break;
      case DOWN_ARROW_KEY:
        event.preventDefault();
        break;
      case E_KEY:
      case DOT_KEY:
      case COMMA_KEY:
        if (type === Types.number) {
          event.preventDefault();
          break;
        }
      default:
        break;
    }
  };
  var inputClasses = classnames_1.default(inputClassName, invalidInputClassName && _defineProperty({}, invalidInputClassName, !isValid));
  return react_1.default.createElement("div", {
    className: className
  }, inputsValues.map(function (value, i) {
    return react_1.default.createElement("input", {
      ref: inputsRefs[i],
      id: utils_1.uuid(),
      name: name,
      "data-id": i,
      autoFocus: autoFocus && i === 0,
      value: value,
      key: inputsKeys[i],
      type: type,
      disabled: disabled,
      className: inputClasses,
      onBlur: onBlur,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onFocus: onFocus,
      pattern: type === Types.number ? '[0-9]*' : undefined
    });
  }));
};
exports.default = CodeInput;